import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import type { Permission } from './OidcProvider';
import { canUsePermission, useAuth } from './OidcProvider';

export function RequirePermission({ permission, children }: PropsWithChildren<{ permission: Permission }>) {
  const { session } = useAuth();
  if (!session) return <Navigate to="/" replace />;
  if (!canUsePermission(session, permission)) return <Forbidden />;
  return children;
}

/** The route guard for a module gated by `requiredAnyPermission`: one of them is enough. */
export function RequireAnyPermission({ permissions, children }: PropsWithChildren<{ permissions: readonly Permission[] }>) {
  const { session } = useAuth();
  if (!session) return <Navigate to="/" replace />;
  if (!permissions.some((permission) => canUsePermission(session, permission))) return <Forbidden />;
  return children;
}

export function Forbidden() {
  return <main className="forbidden-state"><p>Kein Zugriff</p><h1>Dieses Modul ist für dein Konto nicht freigeschaltet.</h1><span>Wende dich an die zuständige Administration, wenn du Zugriff benötigst.</span></main>;
}
